document.addEventListener("DOMContentLoaded", function () {

  function updateBuyNowText() {
    const btn = document.querySelector(".shopify-payment-button__button");

    if (btn) {
      const newText = "🛍️ Buy with Cash on Delivery";

      if (btn.textContent.trim() !== newText) {
        btn.textContent = newText;
      }

      // Button mil gaya, ab observer ki zarurat nahi
      observer.disconnect();
    }
  }

  const observer = new MutationObserver(updateBuyNowText);

  const main = document.querySelector("main") || document.body;

  observer.observe(main, {
    childList: true,
    subtree: true
  });

  updateBuyNowText();

});
document.addEventListener("DOMContentLoaded", function () {

  function startAutoSlider() {

    const nextBtn = document.querySelector(
      'slideshow-component slideshow-arrows .slideshow-control--next, .slideshow-button-next'
    );

    if (!nextBtn) {
      setTimeout(startAutoSlider, 1000);
      return;
    }

    setInterval(function () {
      nextBtn.click();
    }, 3000);

  }

  startAutoSlider();

});